import { FiTrash2 } from '@react-icons/all-files/fi/FiTrash2'
import { MdDeleteForever } from '@react-icons/all-files/md/MdDeleteForever'

// delete something (more clear than IconRemove)

export const IconDeleteFill = MdDeleteForever
export const IconDelete = FiTrash2
